import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ClientForm from '../components/ClientForm';
import ContactFormModal from '../components/ContactFormModal';
import CookieBanner from '../components/CookieBanner';
import GlobalFooter from '../components/GlobalFooter';
import GlobalHeader from '../components/GlobalHeader';
import GlobalNav from '../components/GlobalNav';
import Modal from '../components/Modal';
import '../page/modernizr-custom.js';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

document.addEventListener('DOMContentLoaded', () => {
  const globalHeader = GlobalHeader();
  const globalNav = GlobalNav();
  const globalFooter = GlobalFooter();

  globalHeader.initScrollTrigger();
  globalNav.initGlobalNav();
  globalFooter.initGlobalFooter();

  const scrollToTopBtn = document.getElementById('js-btn-top-container');

  if (scrollToTopBtn) {
    gsap.to(scrollToTopBtn, {
      opacity: 1,
      duration: 0.5,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '#js-trigger',
        start: 'top 200px',
        toggleActions: 'play reverse play reverse', // Show on scroll down, hide on scroll up
        onEnter: () => scrollToTopBtn?.classList.add('active'),
        onLeaveBack: () => scrollToTopBtn?.classList.remove('active'),
        markers: false, // Enable markers for debugging (optional)
      },
    });
  }

  const registerModal = Modal('js-register-modal');
  const registerBtns = document.querySelectorAll('.js-btn-register');
  registerBtns.forEach(registerBtn => {
    registerBtn.addEventListener('click', event => {
      event.preventDefault();
      registerModal.open();
    });
  });

  const mobileContactMenu = Modal('js-mobile-contact-menu');
  const mobileContactMenuBtns = document.querySelectorAll(
    '.js-btn-mobile-contact-menu',
  );
  mobileContactMenuBtns.forEach(mobileContactMenuBtn => {
    mobileContactMenuBtn.addEventListener('click', event => {
      event.preventDefault();
      mobileContactMenu.open();
    });
  });

  const contactFormInit = ContactFormModal();

  if (contactFormInit) {
    const contactusBtns =
      document.querySelectorAll<HTMLButtonElement>('.js-btn-contact');

    contactusBtns.forEach(contactusBtn => {
      contactusBtn.addEventListener('click', (event: MouseEvent) => {
        event.preventDefault();

        const lt = contactusBtn.dataset.lt;
        const id = contactusBtn.dataset.id;

        if (lt && id) {
          contactFormInit.open(lt, id);
        }
      });
    });
  }

  CookieBanner();

  //promo modal
  const promoModal = Modal('js-promo-modal');
  const promoBtns = document.querySelectorAll('.js-btn-promo-modal');

  promoBtns.forEach(promoBtn => {
    promoBtn.addEventListener('click', event => {
      event.preventDefault();
      promoModal.open();
    });
  });

  // auto-open once per browser session
  if (document.getElementById('js-promo-modal')) {
    try {
      if (sessionStorage.getItem('promoModalSeen') !== 'true') {
        sessionStorage.setItem('promoModalSeen', 'true');
        promoModal.open();
      }
    } catch {
      // storage blocked, skip auto-open
    }
  }

  //client forms
  document
    .querySelectorAll<HTMLFormElement>('form.js-client-form')
    .forEach(form => {
      const clientForm = ClientForm();
      form.addEventListener('submit', clientForm.handleSubmit);
    });

  document
    .querySelectorAll<HTMLButtonElement>('.js-scrollto')
    .forEach(button => {
      button.addEventListener('click', () => {
        const targetSelector = button.getAttribute('data-target');

        const targetElement = document.querySelector<HTMLElement>(
          targetSelector || '',
        );

        if (targetElement) {
          gsap.to(window, {
            scrollTo: {
              y: targetElement, // Scroll to the target element
              offsetY: 50, // Optional offset for fixed headers
            },
            duration: 1, // Duration in seconds
            ease: 'power2.out', // Easing function for smooth scroll
          });
        }
      });
    });
});
